var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h1"},[_vm._v("在线考试客户端")])
}
var staticRenderFns = []

export { render, staticRenderFns }